<div class="photoeditor-container">
  <app-annotation-tools
    (menuItemSelect)="onListItemClick($event)"
    [(strokeWidth)]="strokeWidth"
    [(selectedColor)]="selectedColor"
    [(selectedAction)]="selectedAction"
    [(selectedSvgElement)]="selectedSvgElement"
    [selectedElement]="selectionItem"
    [numberingIndex]="numberingIndex"
  ></app-annotation-tools>
  <div class="photoeditor-edit-area" id="annotation-layer" #svgtarget></div>
  <app-annotation-modal [(showModal)]="showModal" [(description)]="description"></app-annotation-modal>
</div>
